(function () {
  'use strict';

  var items = [];
  var frame = 0;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function updateItem(item) {
    if (!item.track.isConnected) return false;
    if (reduceMotion.matches) {
      item.reveal.style.removeProperty('transform');
      item.shade.style.removeProperty('opacity');
      return true;
    }

    var rect = item.track.getBoundingClientRect();
    var distance = Math.max(1, item.track.offsetHeight - item.pin.offsetHeight);
    var progress = clamp(-rect.top / distance, 0, 1);
    item.reveal.style.transform = 'translate3d(0,' + ((1 - progress) * 100) + '%,0)';
    item.shade.style.opacity = String(progress * 0.7);
    return true;
  }

  function update() {
    frame = 0;
    items = items.filter(updateItem);
  }

  function requestUpdate() {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  }

  function resize() {
    requestUpdate();
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-viva-stage-sequence]').forEach(function (track) {
      if (track.dataset.vivaStageRevealReady) return;
      var root = track.closest('[data-viva-stage]');
      var pin = track.querySelector('[data-viva-stage-pin]');
      var shade = track.querySelector('[data-viva-stage-shade]');
      var reveal = track.querySelector('[data-viva-stage-reveal]');
      if (!root || !pin || !shade || !reveal) return;
      track.dataset.vivaStageRevealReady = '1';
      var item = { track: track, pin: pin, shade: shade, reveal: reveal };
      items.push(item);
    });
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', resize);
  reduceMotion.addEventListener('change', requestUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
